import { computedFrom, inject, autoinject } from 'aurelia-framework';
import config from '../../config/config';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';
import { I18N } from 'aurelia-i18n';
import { DialogService } from 'aurelia-dialog';
import { ViewPdfDialog } from './view-pdf.dialog';

@autoinject
export class MyDocuments {
	downloadLink: any;
	documentLists: any;
	showUploadBtn: any;
	showSpinner: any;
	showFilePreview: boolean;
	error: any;

	constructor(private payrazr: PayrazrService, private globalState: State, private i18n: I18N,
		private dialogService: DialogService) {
		// check for null when docs page is navigated to without a session
		let portalId = this.globalState?.business?.portalId ?? '';
		this.downloadLink = `${config.serviceUrl}/portal/${portalId}`;
		// IE does have a PDF viewer embedded; do not show preview for IE users
		this.showFilePreview = !this.isUsingIE();

		this.showUploadBtn = true;
		this.showSpinner = false;
	}

	attached() {
		this.documentLists = [];
		this.getDocumentsList(this.globalState.customer.id);
		this.globalState.associatedCustomers.forEach(customer => {
			this.getDocumentsList(customer.id);
		});
	}

	getDocumentsList(customerId: string) {
		return this.payrazr.getRehabDocumentsList(customerId)
			.then(documents => {
				this.documentLists = this.documentLists.concat(documents);
				this.globalState.documentLists = this.documentLists;
			})
			.catch(error => {
				this.documentLists = [];
				this.error = 'Unable to retrieve documents. Please refresh the page to retry.';
			});
	}

	get documents() {
		let returnList = [];
		if (this.documentLists) {
			this.documentLists.forEach((documentList) => {
				documentList.documents = documentList.documents || [];
				documentList.documents.forEach((document) => {
					document.customerAccountReferenceId = documentList.customerAccountReferenceId;
					document.contactName = documentList.contactName;

					// internally statement pdfs are called 'Invoice Document' but for display purposes we want to say 'Statement PDF'
					if (document.documentType && document.documentType === 'Invoice Document') {
						document.documentType = this.i18n.i18next.t('statementPdf', 'Statement PDF');
					}

					returnList.push(document);
				});
			});
		}
		return returnList;
	}

	downloadFile(fileUrl, saveAsFilename) {
		this.payrazr.downloadFile(fileUrl, saveAsFilename);
	}

	getDownloadTooltipText(documentName: string): string {
		return this.i18n.i18next.t('downloadFile', 'Download File') + ': ' + documentName;
	}

	getPreviewTooltipText(documentName: string): string {
		return this.i18n.i18next.t('previewFile', 'Preview File') + ': ' + documentName;
	}

	isUsingIE(): boolean {
		let ua: string = window.navigator.userAgent;
		// IE versions < 11
		let msIE: number = ua.indexOf('MSIE ');
		// IE version 11
		let trident: number = ua.indexOf('Trident/');

		return msIE > 0 || trident > 0;
	}

	getAndViewPdf(fileUrl: string, fileName: string): void {
		this.showSpinner = true;
		this.payrazr.getFile(fileUrl)
			.then((xhttpResponse: any) => {
				let pdfData = { fileName, blobUrl: URL.createObjectURL(xhttpResponse) };
				this.dialogService.open({ viewModel: ViewPdfDialog, model: pdfData, lock: false });
				this.showSpinner = false;
			})
			.catch(() => {
				this.showSpinner = false;
				alert('An error occured when attempting to preview file.');
			});
	}
}
